export var MAX_RATING_VALUE = 5;